import NibInput from '../NibInput/NibInput';

const InputText = ({ name, label, helperText, tools = ['info'], onAdd = () => {}, formik, ...rest }) => {
  return (
    <NibInput
      tools={tools}
      onAdd={onAdd}
      name={name}
      label={label}
      variant={'filled'}
      onChange={formik.handleChange}
      onBlur={formik.handleBlur}
      style={{ width: '100%' }}
      value={formik.values[name] ?? ''}
      error={formik.touched[name] && formik.errors[name]}
      helperText={helperText}
      {...rest}
    />
  );
};

export default InputText;
